const Workers = [
    {
      id: 1,
      img: 'https://img.freepik.com/free-photo/waist-up-portrait-of-handsome-serious-unshaven-male-keeps-hands-together-dressed-in-dark-blue-shirt-has-talk-with-interlocutor-stands-against-white-wall-self-confident-man-freelancer_273609-16320.jpg?w=2000',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Web dizayner'
    },
    {
      id: 2,
      img: 'https://media.istockphoto.com/id/520884680/photo/manual-worker-with-digital-tablet.jpg?s=612x612&w=0&k=20&c=PyJQH-AAT8n0wCt4v_lPS4NxikCyhbCba_Y4r-5Ct_M=',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 2'
    },
    {
      id: 3,
      img: 'https://static4.depositphotos.com/1000393/362/i/950/depositphotos_3628253-stock-photo-smiling-manual-worker.jpg',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 3'
    },
    {
      id: 4,
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTlphZGy3kMguzv-xWvMxmIKjm2BbGEIIcowxiVDyjeaqNUDWejWmE42wskcNgoj0om4Zc&usqp=CAU',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 4'
    },
    {
      id: 5,
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS484X4zfLrVM9yT1XO3k9naJnUJv8ROI7YUwxfwhcMqsqsNiepnh4QyYqovvxpsT1lwWg&usqp=CAU',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 5'
    },
    {
      id: 6,
      img: 'https://media.istockphoto.com/id/520884680/photo/manual-worker-with-digital-tablet.jpg?s=612x612&w=0&k=20&c=PyJQH-AAT8n0wCt4v_lPS4NxikCyhbCba_Y4r-5Ct_M=',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 6'
    },
    {
      id: 7,
      img: 'https://upload.wikimedia.org/wikipedia/commons/4/48/Outdoors-man-portrait_%28cropped%29.jpg',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 7'
    },
    {
      id: 8,
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVE7RJ7nFSSFfujYqV0oKDKEaKrVDUZtHcsQ&usqp=CAU',
      name: 'Raximjonov Xurshidjon Alisher o‘g‘li',
      post: 'Job Title 8'
    },

  ];
export default Workers